const PAGE_SEEN_PREFIX = 'tour_seen_';
const TRIGGER_INTRO_SEEN_KEY = 'tour_trigger_intro_seen';
const TRIGGER_INTRO_DISMISSED_PREFIX = 'tour_trigger_intro_dismissed:';

function safeGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage can be unavailable (private mode, quota); the backend flag is
    // the source of truth, this is only a per-browser convenience.
  }
}

export function hasSeenPage(key: string): boolean {
  return safeGet(PAGE_SEEN_PREFIX + key) === 'true';
}

export function markPageSeen(key: string): void {
  safeSet(PAGE_SEEN_PREFIX + key, 'true');
}

export function clearPageSeen(key: string): void {
  localStorage.removeItem(PAGE_SEEN_PREFIX + key);
}

/**
 * The one-time "Tours live here" intro is remembered PER USER (#571): one
 * account's dismissal on a shared browser must not silence it for another.
 * The legacy device-wide key still counts as seen so existing users do not
 * get the popover a second time after the upgrade.
 */
export function hasSeenTriggerIntro(userId?: string | null): boolean {
  if (userId && safeGet(TRIGGER_INTRO_SEEN_KEY + ':' + userId) === 'true') return true;
  return safeGet(TRIGGER_INTRO_SEEN_KEY) === 'true';
}

export function markTriggerIntroSeen(userId?: string | null): void {
  safeSet(userId ? TRIGGER_INTRO_SEEN_KEY + ':' + userId : TRIGGER_INTRO_SEEN_KEY, 'true');
}

/**
 * Per-user cache of the backend "Don't show again" flag: lets the shell
 * decide before the current-user query answers, and covers a failed save.
 */
export function hasDismissedTriggerIntro(userId: string | null | undefined): boolean {
  return !!userId && safeGet(TRIGGER_INTRO_DISMISSED_PREFIX + userId) === 'true';
}

export function markTriggerIntroDismissed(userId: string | null | undefined): void {
  if (userId) safeSet(TRIGGER_INTRO_DISMISSED_PREFIX + userId, 'true');
}

export function clearAllSeen(): void {
  Object.keys(localStorage)
    .filter((k) => k.startsWith(PAGE_SEEN_PREFIX)
      || k === TRIGGER_INTRO_SEEN_KEY
      || k.startsWith(TRIGGER_INTRO_SEEN_KEY + ':')
      || k.startsWith(TRIGGER_INTRO_DISMISSED_PREFIX))
    .forEach((k) => localStorage.removeItem(k));
}
